var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"loading":_vm.loading}},[(_vm.properties)?_c('v-card-title',{staticStyle:{"font-size":"1em"}},[_c('span',[_vm._v(" "+_vm._s(_vm.mapTitle)+" ")]),_c('v-spacer'),_c('map-var-selector',{staticStyle:{"max-width":"425px"}})],1):_vm._e(),_c('div',{ref:"mapContainer",attrs:{"id":"mapid"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }